import React from 'react';

function Services({ onSelectService }) {
  return (
    <div className="page-services">
      {/* SECTION HEADER */}
      <section className="section" style={{ paddingBottom: '3rem' }}>
        <div className="section-header">
          <span className="section-tag">Expert Capabilities</span>
          <h2 className="section-title">Our Services</h2>
          <p className="section-subtitle">
            We provide structured digital marketing and computer programming services to help organizations grow in the digital economy.
          </p>
        </div>
      </section>

      {/* SERVICES GRID DETAIL */}
      <section className="section bg-alt-dark" style={{ paddingTop: '3rem' }}>
        <div className="pricing-grid" style={{ maxWidth: '1200px', gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))', gap: '3rem' }}>
          
          {/* DIGITAL MARKETING CARD */}
          <div className="pricing-card" style={{ padding: '2.5rem', cursor: 'pointer' }} onClick={() => onSelectService('Digital Marketing')}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
              <span style={{ fontSize: '2.2rem' }}>📈</span>
              <h3 className="price-title" style={{ margin: 0 }}>Digital Marketing</h3>
            </div>
            <p className="price-desc">
              We help businesses improve their online visibility and connect with their target audience through effective digital marketing strategies.
            </p>
            <ul className="price-features" style={{ margin: 0 }}>
              <li className="price-feature-item"><span className="check-icon">✓</span> Search Engine Optimization (SEO)</li>
              <li className="price-feature-item"><span className="check-icon">✓</span> Social media marketing</li>
              <li className="price-feature-item"><span className="check-icon">✓</span> Content marketing</li>
              <li className="price-feature-item"><span className="check-icon">✓</span> Digital advertising</li>
            </ul>
            <div style={{ marginTop: 'auto', paddingTop: '1.5rem', color: 'var(--accent-color)', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
              Explore Capability <span style={{ fontSize: '1.1rem' }}>→</span>
            </div>
          </div>

          {/* IT CONSULTANCY CARD */}
          <div className="pricing-card popular" style={{ padding: '2.5rem', cursor: 'pointer' }} onClick={() => onSelectService('IT Consultancy')}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
              <span style={{ fontSize: '2.2rem' }}>🧑‍💼</span>
              <h3 className="price-title" style={{ margin: 0, color: 'var(--text-primary)' }}>IT Consultancy</h3>
            </div>
            <p className="price-desc" style={{ color: 'var(--text-secondary)' }}>
              Our IT consultancy services help businesses understand and implement technology according to their requirements.
            </p>
            <ul className="price-features" style={{ margin: 0 }}>
              <li className="price-feature-item" style={{ color: 'var(--text-secondary)' }}><span className="check-icon">✓</span> IT Strategy planning</li>
              <li className="price-feature-item" style={{ color: 'var(--text-secondary)' }}><span className="check-icon">✓</span> Technology consulting</li>
              <li className="price-feature-item" style={{ color: 'var(--text-secondary)' }}><span className="check-icon">✓</span> Digital transformation advisory</li>
            </ul>
            <div style={{ marginTop: 'auto', paddingTop: '1.5rem', color: 'var(--accent-color)', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
              Explore Capability <span style={{ fontSize: '1.1rem' }}>→</span>
            </div>
          </div>

          {/* WEB & DIGITAL SOLUTIONS CARD */}
          <div className="pricing-card" style={{ padding: '2.5rem', cursor: 'pointer' }} onClick={() => onSelectService('Web & Digital Solutions')}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
              <span style={{ fontSize: '2.2rem' }}>🌐</span>
              <h3 className="price-title" style={{ margin: 0 }}>Web & Digital Solutions</h3>
            </div>
            <p className="price-desc">
              We provide digital solutions that help businesses establish a professional and effective online presence.
            </p>
            <ul className="price-features" style={{ margin: 0 }}>
              <li className="price-feature-item"><span className="check-icon">✓</span> Website solutions development</li>
              <li className="price-feature-item"><span className="check-icon">✓</span> Custom Digital platforms</li>
              <li className="price-feature-item"><span className="check-icon">✓</span> Business technology solutions</li>
            </ul>
            <div style={{ marginTop: 'auto', paddingTop: '1.5rem', color: 'var(--accent-color)', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
              Explore Capability <span style={{ fontSize: '1.1rem' }}>→</span>
            </div>
          </div>
        </div>

        {/* REGISTERED BUSINESS IT & COMPUTER SERVICES */}
        <div 
          style={{ maxWidth: '900px', margin: '4rem auto 0 auto', padding: '2.5rem', background: 'var(--bg-secondary)', borderRadius: '12px', border: '1px solid var(--border-color)', textAlign: 'center', cursor: 'pointer' }}
          onClick={() => onSelectService('Computer & IT Services')}
        >
          <span style={{ fontSize: '2.5rem', display: 'block', marginBottom: '1rem' }}>💻</span>
          <h3 className="feature-title" style={{ marginBottom: '1rem' }}>Computer & IT Services</h3>
          <p className="feature-desc" style={{ maxWidth: '650px', margin: '0 auto 1.5rem auto', fontSize: '1.05rem', lineHeight: '1.7', color: 'var(--text-secondary)' }}>
            Our registered business activity includes computer programming, consultancy and other information 
            technology and computer services tailored to corporate client specifications.
          </p>
          <div style={{ color: 'var(--accent-color)', fontWeight: 'bold', display: 'inline-flex', alignItems: 'center', gap: '0.4rem' }}>
            Explore Programming Details <span style={{ fontSize: '1.1rem' }}>→</span>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Services;
